<template>
    <layout>
        <template  #content>
            <div class="w-3/4 tablet:w-full mx-auto">
                <form class="grid grid-cols-2 gap-5" id="customer_details">
                    <div>
                        <label for="firstName">{{translate('first_name')}}</label>
                        <input id="firstName" v-model="checkoutStore.customerDetails.firstName" type="text" required>
                        <span class="text-red-400 text-sm mt-1" v-if="triedToSubmit && !!formErrors.firstName">
                           {{ translate(formErrors.firstName) }}
                       </span>
                    </div>
                    <div>
                        <label for="lastName">{{translate('last_name')}}</label>
                        <input id="lastName" v-model="checkoutStore.customerDetails.lastName" type="text">
                        <span class="text-red-400 text-sm mt-1" v-if="triedToSubmit && !!formErrors.lastName">
                            {{ translate(formErrors.lastName) }}
                       </span>
                    </div>
                    <div class="col-span-full">
                        <label for="email">{{translate('email')}}</label>
                        <input id="email" v-model="checkoutStore.customerDetails.email" type="email">
                        <span class="text-red-400 text-sm mt-1" v-if="triedToSubmit && !!formErrors.email">
                            {{ translate(formErrors.email) }}
                       </span>
                    </div>
                    <div class="col-span-full">
                        <label for="phone">{{translate('phone')}}</label>
                        <input id="phone" v-model="checkoutStore.customerDetails.phone" type="tel">
                        <span class="text-red-400 text-sm mt-1" v-if="triedToSubmit && !!formErrors.phone">
                            {{ translate(formErrors.phone) }}
                       </span>
                    </div>
    
                    <div class="col-span-full" v-if="!isCw">
                        <label for="registrationNumber">{{translate('kvk_nummer')}}</label>
                        <input id="registrationNumber" v-model="checkoutStore.customerDetails.registrationNumber" type="text"  @input="checkoutStore.checkNlVatValidity">
                        <span class="text-red-400 text-sm mt-1" v-if="triedToSubmit && !!formErrors.registrationNumber">
                            {{ translate(formErrors.registrationNumber) }}
                       </span>
                    </div>

                    <div class="col-span-full">
                        <label for="vatNumber" class="flex justify-between items-end">
                            {{isCw ? translate('vat') : translate('btw_nummer')}} 
                            <template v-if="!isCw">
                                <span class="text-xs text-primary-400" v-if="checkoutStore.isCheckingNlVat"><i class="far fa-spinner"></i></span>
                                <span class="text-xs text-barometer-green" v-else-if="checkoutStore.isValidNlVat"><i class="far fa-check-circle"></i> {{translate('valid')}}</span>
                                <span class="text-xs text-barometer-red" v-else-if="!!checkoutStore.customerDetails.vatNumber"><i class="far fa-times"></i> {{translate('invalid')}}</span>
                            </template>
                        </label>
                        <input v-if="isCw" id="vatNumber" v-model="checkoutStore.customerDetails.vatNumber" type="text">
                        <input v-else id="vatNumber" v-model="checkoutStore.customerDetails.vatNumber" type="text" @input="checkoutStore.checkNlVatValidity">
                        <span class="text-red-400 text-sm mt-1" v-if="triedToSubmit && !!formErrors.vatNumber">
                            {{ translate(formErrors.vatNumber) }}
                       </span>
                    </div>
    
                    <div class="col-span-full">
                        <label for="message">{{translate('bericht')}}</label>
                        <textarea rows="4" id="message" v-model="checkoutStore.customerDetails.message"></textarea>
                    </div>
                </form>
            </div>
        </template>
        <template #sidebar>
            <button class="btn btn-primary w-full" @click.prevent="onSubmit">{{translate('volgende')}}</button>
            <button class="btn btn-ghost w-full mt-3" v-if="checkoutStore.canGoToPrevPage" @click.prevent="checkoutStore.prevPage()">{{translate('vorige')}}</button>
        </template>
    </layout>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {useStore} from "../../store";
import Translation from "../../../../components/translation.vue";
import Layout from "./layout.vue";

interface FormValidation {
    firstName: string | null;
    lastName: string | null;
    phone: string | null;
    email: string | null;
    registrationNumber: string | null;
    vatNumber: string | null;
}

export default defineComponent({
    name: "customer-details",
    components: {Translation,Layout},
    data() {
        return {
            checkoutStore: useStore(),
            triedToSubmit: false
        }   
    },
    computed: {
        isCw(): boolean {
            return this.checkoutStore.brand === "companyweb";
        },
        formErrors(): FormValidation {
            return {
                firstName: this.checkoutStore.customerDetails.firstName === "" ? "validation_error_required" : null,
                lastName: this.checkoutStore.customerDetails.lastName === "" ? "validation_error_required" : null,
                phone: this.checkoutStore.customerDetails.phone === "" 
                    ? "validation_error_required" 
                    : !this.checkoutStore.customerDetails.phone?.isValidPhoneNumber()
                        ? "validation_error_phone"
                        : null,
                email: this.checkoutStore.customerDetails.email === "" 
                    ? "validation_error_required" 
                    : !this.checkoutStore.customerDetails.email?.isValidEmailAddress()
                        ? "validation_error_email"
                        : null,
                registrationNumber: !this.isCw && this.checkoutStore.customerDetails.registrationNumber === ""
                    ? "validation_error_required" 
                    : null,
                vatNumber: this.isCw && this.checkoutStore.customerDetails.vatNumber === "" 
                    ? "validation_error_required"
                    : this.isCw && !this.checkoutStore.customerDetails.vatNumber?.isValidVat()
                        ? "validation_error_vat"
                        : null,
            }
        },
        hasFormErrors(): boolean {
            return !!this.formErrors.firstName ||
                !!this.formErrors.lastName ||
                !!this.formErrors.phone ||
                !!this.formErrors.email ||
                !!this.formErrors.registrationNumber ||
                !!this.formErrors.vatNumber;
        }
    },
    methods: {
        onSubmit(): void {
            this.triedToSubmit = true;
            
            if (!this.hasFormErrors)
                this.checkoutStore.nextPage();
        }
    },
    mounted() {
        if(!this.isCw)
            this.checkoutStore.checkNlVatValidity();
    }
})
</script>